import useBreakpoint from '@utils/useBreakpoint';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
import WalletConnectBtn from '@moncler/components/nft/WalletConnectBtn';
import analytics from '@common/utils/analytics';
const AccountMenuMobile = (props) => {
    const [loggedIn, setLoggedIn] = useState(window.loggedin);
    const [wishlistCount, setWishlistCount] = useState(window.wishlistIds.length);
    const { t } = useTranslation();
    const breakpoint = useBreakpoint();
    const isEmployeeSales = window.isEmployeeSales;
    useEffect(() => {
        customEventBus.on('account:update', (data) => {
            let adding = false;
            if (data === null || data === void 0 ? void 0 : data.wishlistIds) {
                if (data.wishlistIds.length > window.wishlistIds.length) {
                    // adding to wishlist
                    adding = true;
                }
                if (breakpoint <= window.mqObj.md) {
                    window.wishlistIds = data.wishlistIds;
                }
                setWishlistCount(data.wishlistIds.length);
            }
            else {
                // window.loggedin updated
                setLoggedIn(window.loggedin);
            }
        });
        //center menu
        const selectedPage = document.querySelector('.section-menu-new-wrapper .section-menu-new li.selected');
        setTimeout(() => {
            selectedPage === null || selectedPage === void 0 ? void 0 : selectedPage.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }, 1000);
    }, []);
    // call analytics if effective social login
    useEffect(() => {
        const authProvider = new URLSearchParams(window.location.search).get('oauthProvider');
        if (authProvider) {
            let regex = /[a-zA-Z]+/g; // remove spatial chars from Facebook#_=_
            authProvider.match(regex)[0];
            analytics.socialLoginGeneric({ event: 'my moncler', eventCategory: 'my moncler', eventAction: `${authProvider.toLowerCase()}-login`, eventLabel: 'login' });
            window.history.pushState({}, document.title, window.location.pathname);
        }
    }, []);
    if (breakpoint >= window.mqObj.md) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "account-wrapper__item" },
            React.createElement("a", { href: loggedIn ? props.myaccountUrl : window.loginUrl, className: classNames('account-cta', { 'with-wishlisticon': wishlistCount > 0 }), "data-analytics": `{"event": "menu", "eventCategory": "account menu", "eventAction": ${loggedIn ? '"my moncler"' : '"login"'}}` },
                React.createElement("span", { className: loggedIn ? 'icon--account-logged' : 'icon--account' }),
                React.createElement("span", { className: "account-cta__label" }, t(loggedIn ? 'label.mymoncler' : 'account.login'))),
            loggedIn && (React.createElement("a", { href: props.logoutUrl, className: "account-logout", "data-analytics": '{"event": "menu", "eventCategory": "account menu", "eventAction": "log out"}' }, t('label.signout')))),
        React.createElement("div", { className: "account-wrapper__item" },
            React.createElement("a", { href: loggedIn ? props.wishlistLoggedUrl : props.wishlistGuestUrl, className: "account-cta", "data-analytics": '{"event": "header", "eventCategory": "header", "eventAction": "wishlist"}' },
                React.createElement("span", { className: `icon--heart-${wishlistCount > 0 ? 'filled' : 'empty'}-black` }),
                React.createElement("div", { className: "account-cta__label" },
                    t('profile.wishlist'),
                    wishlistCount > 0 && React.createElement(React.Fragment, null,
                        " (",
                        wishlistCount,
                        ")")))),
        !isEmployeeSales && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "account-wrapper__item" },
                React.createElement("a", { href: props.clientserviceUrl, "data-analytics": '{"event": "header", "eventCategory": "header", "eventAction": "contact us"}', className: "account-cta" },
                    React.createElement("span", { className: "icon--client-service" }),
                    React.createElement("span", { className: "account-cta__label" }, t('footer.clientservice.title')))),
            React.createElement(WalletConnectBtn, { btnClass: "primary-s d-flex-align-center", icon: true, analyticsCategory: "menu", analyticsAction: "wallet connect" })))));
};
export default AccountMenuMobile;
